import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { User } from '../authentication/model/user.model';
import { TableRequest } from '../../models/table/table-request.model';
import { TableResponse } from '../../models/table/table-response.model';
import { ErrorCode } from '../../models/error-code.model';
import { NewUser } from '../../models/user-management/new-user.model';
import { HttpErrorResponse } from '@angular/common/http';
import { UserMessageDTO } from '../../models/user-management/user-message-dto.model';

export const UserManagementApiActions = createActionGroup({
    source: 'API/UserManagement',
    events: {
        'load users': props<{ request: TableRequest }>(),
        'update user': props<{ user: NewUser; changePassword: boolean }>(),
        'create user': props<{ user: NewUser; isGuestAccount: boolean }>(),
        'delete users': props<{ userIds: number[] }>(),
        'send message': props<{ message: UserMessageDTO }>()
    }
});

export const UserManagementActions = createActionGroup({
    source: 'UserManagement',
    events: {
        'load users success': props<{ response: TableResponse<User> }>(),
        'load users failure': props<{ error: ErrorCode }>(),
        'update all selected users': props<{ users: User[] }>(),
        'remove selected user': props<{ userToRemove: User }>(),
        'update user success': props<{ updatedUser: User }>(),
        'update user failure': props<{ error: HttpErrorResponse }>(),
        'create user success': props<{ newUser: User }>(),
        'create user failure': props<{ error: HttpErrorResponse }>(),
        'delete user success': props<{ userIds: number[] }>(),
        'delete user failure': props<{ error: ErrorCode }>(),
        'change user table data': emptyProps(),
        'send message success': props<{ userAccountIds: number[] }>(),
        'send message failure': props<{ error: ErrorCode }>()
    }
});
